import { Loader2 } from "lucide-react"
import { cn } from "@/shared/utils"

interface LoadingSpinnerProps {
  message?: string;
  className?: string;
}

export default function LoadingSpinner({
  message = 'Loading...',
  className,
}: LoadingSpinnerProps) {
  return (
    <div className={cn("flex flex-col items-center justify-center min-h-[200px] p-8", className)}>
      <Loader2 className="h-12 w-12 animate-spin text-primary" />
      {message && <p className="mt-4 text-sm text-muted-foreground">{message}</p>}
    </div>
  );
}
